// 是否开启/*  */
const ubaInfo = {};
Object.defineProperty(ubaInfo, "enabled", {
  get() {
    return dsf.config.UBA.enabled || false;
  }
});

function loader() {
  return import(/*webpackChunkName:"UBA"*/ "../uba/index").then((res) => {
    let module = dsf.getEsModule(res);
    return module;
  });
}
function urlWatch(state, to, form, view) {
  if (!ubaInfo.enabled) {
    return;
  }
  return loader().then((module) => {
    module.urlWatch()?.[state]?.(to, form, view);
  });
}

export default {
  urlWatch
};
